import { render, staticRenderFns } from "./MaterielTypeManager.vue?vue&type=template&id=4f6caf5a&scoped=true&"
import script from "./MaterielTypeManager.vue?vue&type=script&lang=js&"
export * from "./MaterielTypeManager.vue?vue&type=script&lang=js&"
import style0 from "./MaterielTypeManager.vue?vue&type=style&index=0&id=4f6caf5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6caf5a",
  null
  
)

export default component.exports